import { RespuestaLecturaError } from '../../Mensajes';
import { llamadaAPI_GET, llamadaAPI_GETBinario, llamadaAPI_POST, llamadaAPI_PUT } from '../../SQL';
import { TratamientoDeParametroParaURI, TratamientoDeVariableBoolean } from '../../Varios';

export const function_VEN_Recibos_Cabecera_Listar = async (FechaDesde, FechaHasta) => {
    const NombreFuncion = "function_VEN_Recibos_Cabecera_Listar"

    try {
        const resulData = await llamadaAPI_GET("VEN_Recibos_Cabecera/Listar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Recibos_Cabecera_ListarRetencionesPercibidas = async (FechaDesde, FechaHasta, Where) => {
    const NombreFuncion = "function_VEN_Recibos_Cabecera_ListarRetencionesPercibidas"

    try {
        const resulData = await llamadaAPI_GET("VEN_Recibos_Cabecera/ListarRetencionesPercibidas/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta + "/" +
            await TratamientoDeParametroParaURI(Where));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Recibos_Cabecera_ListarCobranzas = async (FechaDesde, FechaHasta, Where) => {
    const NombreFuncion = "function_VEN_Recibos_Cabecera_ListarCobranzas"

    try {
        const resulData = await llamadaAPI_GET("VEN_Recibos_Cabecera/ListarCobranzas/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta + "/" +
            await TratamientoDeParametroParaURI(Where));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Recibos_Cabecera_ListarCobranzasDetalles = async (FechaDesde, FechaHasta, Where) => {
    const NombreFuncion = "function_VEN_Recibos_Cabecera_ListarCobranzasDetalles"

    try {
        const resulData = await llamadaAPI_GET("VEN_Recibos_Cabecera/ListarCobranzasDetalles/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta + "/" +
            await TratamientoDeParametroParaURI(Where));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Recibos_Cabecera_Leer = async (IdRecibo) => {
    const NombreFuncion = "function_VEN_Recibos_Cabecera_Leer"

    try {
        const resulData = await llamadaAPI_GET("VEN_Recibos_Cabecera/Leer/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdRecibo);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Recibos_Cabecera_LeerPorFecha = async (FechaDesde, FechaHasta) => {
    const NombreFuncion = "function_VEN_Recibos_Cabecera_LeerPorFecha"

    try {
        const resulData = await llamadaAPI_GET("VEN_Recibos_Cabecera/LeerPorFecha/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Recibos_Generar_JSON = async (IdRecibo,
    Fecha, IdCliente, NumeroFantasia, CodigoPuntoFiscal, Numero, CodigoMoneda, Cotizacion,
    Observaciones, ImporteBonificaciones, ImporteRecargos,
    ColeccionImputacionesFinanciera, ColeccionImpuestos, ColeccionImputacionesContable,
    ColeccionRelacionesDocsVentaRecibos, ColeccionImputacionesFinancieraRecargosBonificaciones) => {
    const NombreFuncion = "function_VEN_Recibos_Generar_JSON";

    try {
        const tiposNegativos = [2, 12, 22, 32, 42, 52, 62, 72, 82, 92];

        const totalDocumentos = ColeccionRelacionesDocsVentaRecibos.reduce((total, detalle) => {
          const signo = tiposNegativos.includes(detalle.IdTipoDocVenta) ? -1 : 1;
          return total + (signo * detalle.Importe);
        }, 0);

        const totalImporteFormasDePago = ColeccionImputacionesFinanciera.reduce((total, detalle) => total + detalle.Importe, 0);
        const totalImporteImpuestos = ColeccionImpuestos.reduce((total, detalle) => total + detalle.Importe, 0);
        const totalImporteTotalAPagarPostImpuestos = totalDocumentos - totalImporteImpuestos;

        if (!ImporteBonificaciones) {
            ImporteBonificaciones = 0
        }

        if (!ImporteRecargos) {
            ImporteRecargos = 0
        }

        const JSON = {
            IdRecibo: IdRecibo,
            CodigoCompania: localStorage.getItem("CodigoCompania"),
            CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
            CodigoPlanta: localStorage.getItem("CodigoPlanta"),
            Fecha: Fecha,
            FechaPago: Fecha,
            FechaPagoCompromiso: Fecha,
            IdCliente: IdCliente,
            NumeroFantasia: NumeroFantasia,
            CodigoPuntoFiscal: CodigoPuntoFiscal,
            Numero: Numero,
            CodigoMoneda: CodigoMoneda,
            Cotizacion: Cotizacion,
            IdCierreCaja: 0,
            IdEstado: 255,
            Terminal: localStorage.getItem("Terminal"),
            Observaciones: Observaciones,
            ImporteTotalAPagar: totalDocumentos,
            ImporteTotalRecibo: totalDocumentos,
            ImporteTotalAPagarPostImpuestos: totalImporteTotalAPagarPostImpuestos,
            ImporteBonificaciones: ImporteBonificaciones,
            ImporteRecargos: ImporteRecargos,
            ImputacionesFinanciera: ColeccionImputacionesFinanciera.map(original => ({
                ...original,
                CodigoCompania: localStorage.getItem("CodigoCompania"),
                CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
                CodigoPlanta: localStorage.getItem("CodigoPlanta")
            })),
            Impuestos: ColeccionImpuestos.map(original => ({
                ...original,
                CodigoCompania: localStorage.getItem("CodigoCompania"),
                CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
                CodigoPlanta: localStorage.getItem("CodigoPlanta")
            })),
            ImputacionesContable: ColeccionImputacionesContable.map(original => ({
                ...original,
                CodigoCompania: localStorage.getItem("CodigoCompania"),
                CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
                CodigoPlanta: localStorage.getItem("CodigoPlanta")
            })),
            RelacionesDocsVentaRecibos: ColeccionRelacionesDocsVentaRecibos.map(original => ({
                ...original,
                CodigoCompania: localStorage.getItem("CodigoCompania"),
                CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
                CodigoPlanta: localStorage.getItem("CodigoPlanta")
            })),
            ImputacionesFinancieraRecargosBonificaciones: ColeccionImputacionesFinancieraRecargosBonificaciones.map(original => ({
                ...original,
                CodigoCompania: localStorage.getItem("CodigoCompania"),
                CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
                CodigoPlanta: localStorage.getItem("CodigoPlanta")
            }))
        };

        return JSON;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_VEN_Recibos_Cabecera_Insertar = async (Recibo, EsReciboDeAnticipo = 0, DebeCrearAnticipo = 0) => {
    const NombreFuncion = "function_VEN_Recibos_Cabecera_Insertar";

    try {
        const reciboResult = await llamadaAPI_POST("VEN_Recibos_Cabecera/InsertarCompleto/" +
            TratamientoDeVariableBoolean(EsReciboDeAnticipo) + "/" +
            TratamientoDeVariableBoolean(DebeCrearAnticipo), Recibo);
        return reciboResult;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_VEN_Recibos_Cabecera_Eliminar = async (IdRecibo) => {
    const NombreFuncion = "function_VEN_Recibos_Cabecera_Eliminar"

    try {
        const resulData = await llamadaAPI_PUT("VEN_Recibos_Cabecera/Eliminar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdRecibo);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Recibos_Cabecera_ReporteRecibo = async (IdRecibo, formato) => {
    const NombreFuncion = "function_VEN_Recibos_Cabecera_ReporteRecibo";

    try {
        const resulData = await llamadaAPI_GETBinario("VEN_Recibos_Cabecera/GenerarDocumento/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdRecibo);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Recibos_Cabecera_ReporteRecibo_EnvioMail = async (IdRecibo, toEmail) => {
    const NombreFuncion = "function_VEN_Recibos_Cabecera_ReporteRecibo_EnvioMail";

    try {
        const resulData = await llamadaAPI_GET("VEN_Recibos_Cabecera/EnvioMail/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdRecibo + "/" +
            await TratamientoDeParametroParaURI(toEmail));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};